import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  LinearProgress,
  Box
} from '@mui/material';
import type { VendedorKpi } from '@azoupvendas/shared';

// AIDEV-NOTE: Tabela ranking da equipe do gerente — ordena por totalVendas desc
interface TeamRankingTableProps {
  ranking: VendedorKpi[];
}

export function TeamRankingTable({ ranking }: TeamRankingTableProps) {
  const sorted = [...ranking].sort((a, b) => b.totalVendas - a.totalVendas);

  if (sorted.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        Nenhum vendedor na equipe.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Vendedor</TableCell>
            <TableCell align="right">Pedidos</TableCell>
            <TableCell align="right">Total Vendas</TableCell>
            <TableCell align="right" sx={{ minWidth: 140 }}>
              Meta
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.map((v, idx) => (
            <TableRow key={v.vendedorId}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{v.nome}</TableCell>
              <TableCell align="right">{v.pedidosCount}</TableCell>
              <TableCell align="right">
                {v.totalVendas.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </TableCell>
              <TableCell align="right">
                {v.metaPercent !== null ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={Math.min(100, v.metaPercent)}
                      sx={{ flex: 1, height: 8, borderRadius: 4 }}
                    />
                    <Typography variant="caption" sx={{ minWidth: 40 }}>
                      {v.metaPercent.toFixed(0)}%
                    </Typography>
                  </Box>
                ) : (
                  <Typography variant="caption" color="text.secondary">
                    N/A
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
